import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'

export default function CarWheels({ position = [0, 20, 0], isRotate = false }) {
    const wheelsNodes = useGLTF('./models/car/carWheels.glb')
    const wheelsTexture = useTexture('./textures/car/carWheels.jpg')
    wheelsTexture.flipY = false

    const CarWheels = useRef()

    useFrame(() => {
        if (isRotate) {
            CarWheels.current.rotation.x += 0.1 
        }
    })

    return (
        <mesh
            ref={CarWheels}
            geometry={wheelsNodes.nodes.carWheels.geometry}
            position={position}
            onClick={(event) => event.stopPropagation()}
            onPointerEnter={(event) => event.stopPropagation()}
        >
            <meshBasicMaterial map={wheelsTexture} />
        </mesh>
    )
}
